import EmptyData from 'components/EmptyData';
import icon from './images/emptyIcon.png';

export default function Empty() {
    return <EmptyData image={icon} description={__('No Data Found')} />;
}
